// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module__banner___1wq6f","icon":"Banner-module__icon___ubrk9"};